import { render, staticRenderFns } from "./arrow.vue?vue&type=template&id=4c793880&"
import script from "./arrow.vue?vue&type=script&lang=js&"
export * from "./arrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports